import { Outlet } from "react-router";
import CommonHero from "../layout/common/commonHero";
import Navbar from "../layout/homePage/navbar/navbar";
import HomePageFooter from "../layout/homePage/footer/HomePageFooter";
import AboutUs from "../layout/homePage/aboutUs/aboutUs";

export default function About() {
   return (

     <>
    <Navbar />
    <CommonHero />
    <AboutUs/>
    <Outlet />
    <HomePageFooter />
  </>

  );
}